// zip-based-stock.js

if (typeof window.__ZIP_LABELS_INITIALIZED__ === 'undefined') {
  window.__ZIP_LABELS_INITIALIZED__ = true;

  // Maps tag fragments to delivery codes
  const tagToStockCode = {
    'Discontinued': 'DS',
    'Stock_TXWH': 'TXS',
    'Stock_TX_D_1': 'TXS',
    'Stock_TX_W_1': 'TX7',
    'Stock_US_W_2': 'TX7',
    'Stock_MDWH': 'MDS',
    'Stock_MD_D_1': 'MDS',
    'Stock_MD_W_1': 'MD7',
    'Stock_NJ_W_1': 'MD7',
    'Stock_PALF_W_1': 'MD7',
    'Stock_NC_D_1': 'MD7',
    'Stock_NC_W_1': 'MD7',
    'Stock_CA_D_1': 'CAS',
    'Stock_CA_W_1': 'CA7',
    'Stock_LD_W_1': 'CA7',
    'Stock_CH_W_1': 'CA7'
  };

  // Define ZIP code groups
  const groupTX = ["75", "76", "77", "78", "79","35", "36", "71", "72", "80", "81", "32", "33", "34", "30", "31", "39", "83", "60", "61", "62", "46", "47", "48", "50", "51", "52", "66", "67","40", "41", "42", "70", "71", "55", "56", "38", "39", "63", "64", "65", "59", "68", "69", "87", "88", "58", "73", "74", "57", "37", "38", "53", "54", "82", "83"];
  const groupMD = ["20", "21", "22", "23", "24", "06", "19", "03", "04", "01", "02", "48", "49", "07", "08", "10", "11", "12", "13", "14", "27", "28", "43", "44", "45", "15", "16", "17", "18", "19", "29", "25", "26", "05"];
  const groupCA = ["90", "91", "92", "93", "94", "95", "96","85", "86", "89", "97", "84","98", "99"];

// Define vendor groups
const txVendors = ["Happy Homes", "Steve Silver", "Midinmod", "Nova Furniture", "Essentials For Living", "Homelegance","Homey Design","Four Hands"];
const mdVendors = ["Luna Luxury", "ESF Furniture", "Sagebrook Home", "Global USA"];
const nationalVendors = ["Ashley", "Crown Mark", "Furniture of America", "Coaster"];

function getZipPrefix(zip) {
  return zip?.substring(0, 2);
}

function determineStockCode(tags, zipPrefix, vendor) {
  const codes = new Set();

  for (let tag of tags) {
    for (let key in tagToStockCode) {
      if (tag === key) {
        const code = tagToStockCode[key];
        codes.add(code);
      }
    }
  }

  // Local vendor override (ignores ZIP code)
  if (txVendors.includes(vendor)) {
    if (codes.has("TXS")) return "TXS";
    if (codes.has("TX7")) return "TX7";
  } else if (mdVendors.includes(vendor)) {
    if (codes.has("MDS")) return "MDS";
    if (codes.has("MD7")) return "MD7";
  } else {
    // ZIP-based fallback for national vendors and others
    if (codes.has("TXS") && groupTX.includes(zipPrefix)) return "TXS";
    if (codes.has("TX7") && groupTX.includes(zipPrefix)) return "TX7";
    if (codes.has("MDS") && groupMD.includes(zipPrefix)) return "MDS";
    if (codes.has("MD7") && groupMD.includes(zipPrefix)) return "MD7";
    if (codes.has("CAS") && groupCA.includes(zipPrefix)) return "CAS";
    if (codes.has("CA7") && groupCA.includes(zipPrefix)) return "CA7";
  }

  return null; // Fallback
}

function getLabelText(stockCode) {
  if (stockCode === 'DS') {
    return null;
  } else if (stockCode === 'TXS' || stockCode === 'MDS' || stockCode === 'CAS') {
    return "In Stock | Ready to Go";
  } else if (stockCode === 'TX7' || stockCode === 'MD7' || stockCode === 'CA7') {
    return "In Stock";
  }
  return null;
}

function applyLabels() {
  const zipCode = localStorage.getItem("visitorZipCode") || "77036";
  const zipPrefix = getZipPrefix(zipCode);

  const productCards = document.querySelectorAll('[data-stock-tags]');
  productCards.forEach(card => {
    const tags = card.getAttribute('data-stock-tags').split(',');
    const vendor = card.getAttribute('data-vendor');

    const stockCode = determineStockCode(tags, zipPrefix, vendor);
    const labelText = getLabelText(stockCode);

    const label = card.querySelector('.product-label.product-label--sale');
    if (labelText && label) {
      label.textContent = labelText;
      label.style.display = 'inline-block';
    } else if (label) {
      label.style.display = 'none';
    }
  });
}

setTimeout(applyLabels, 1000);
    // Re-apply labels after filters are applied
document.addEventListener('on:facet-filters:updated', () => {
  setTimeout(applyLabels, 100); // small delay to ensure DOM is ready
  });
window.applyZipBasedLabels = applyLabels;
} else {
 
}